import { useLoadingStore } from '@centric-os/stores/loading/use-loading-store';
import { storeToRefs } from 'pinia';
import { ref, watch } from 'vue';

type RequestFunction = () => Promise<void> | ((...args: any[]) => Promise<void>);

export default () => {
  const loadingStore = useLoadingStore();
  const { loading } = storeToRefs(loadingStore);

  const queue = ref<RequestFunction[]>([]);

  const addToNetworkQueue = (request: RequestFunction): void => {
    const isRequestInQueue = queue.value.find((req) => req?.name === request?.name);

    if (isRequestInQueue) {
      return;
    }
    queue.value.push(request);
    if (!loading.value) {
      processQueue(); // Start processing if not loading
    }
  };

  const processQueue = async (): Promise<void> => {
    if (queue.value?.length) {
      const nextRequest = queue.value.shift();
      await nextRequest();

      processQueue(); // Continue processing the queue
    }
  };

  watch(loading, (newVal: boolean) => {
    if (!newVal) {
      processQueue(); // Process next request when loading is complete
    }
  });

  return {
    addToNetworkQueue,
  };
};
